import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFigma24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconFigma24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8.347 9.494A3 3 0 0 1 7 6.99C7 5.338 8.326 4 9.962 4h5.076C16.674 4 18 5.338 18 6.989a2.99 2.99 0 0 1-1.347 2.505A3 3 0 0 1 18 12c0 1.65-1.326 2.989-2.962 2.989h-.054a2.94 2.94 0 0 1-2.005-.79v2.785A3.014 3.014 0 0 1 9.976 20 2.987 2.987 0 0 1 7 17.011c0-1.049.536-1.972 1.347-2.505A2.99 2.99 0 0 1 7 12c0-1.05.536-1.973 1.347-2.506M12.98 12c0 1.117.897 2.023 2.005 2.023h.054A2.014 2.014 0 0 0 17.043 12a2.014 2.014 0 0 0-2.005-2.023h-.054A2.014 2.014 0 0 0 12.979 12m-.958-2.023H9.962A2.014 2.014 0 0 0 7.957 12c0 1.115.894 2.02 1.999 2.023h2.065zM9.962 14.99h-.006a2.014 2.014 0 0 0-1.999 2.022c0 1.114.908 2.023 2.019 2.023a2.053 2.053 0 0 0 2.045-2.05V14.99zm2.06-5.978h-2.06A2.014 2.014 0 0 1 7.957 6.99c0-1.118.898-2.023 2.005-2.023h2.06zm3.016 0h-2.06V4.966h2.06c1.107 0 2.005.905 2.005 2.023a2.014 2.014 0 0 1-2.005 2.022"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFigma24);
